import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { Button } from '@totango-app-team/ui-shared-components';
import isEmpty from 'lodash/isEmpty';

import Input from 'Components/input/input';

export default function SetUserDetails(props) {
	const {
		handleNext,
		title,
		firstName,
		setFirstName,
		lastName,
		setLastName,
		jobTitle,
		companyCity,
		companyState,
		companyCountry,
		setJobTitle,
		setCompanyCity,
		setCompanyState,
		setCompanyCountry,
		isActiveStep,
	} = props;
	const [isValid, setIsValid] = useState(false);

	const onFirstNameChange = useCallback(
		e => {
			e.persist();
			setFirstName(e.target.value);
		},
		[setFirstName],
	);

	const onLastNameChange = useCallback(
		e => {
			e.persist();
			setLastName(e.target.value);
		},
		[setLastName],
	);

	const onJobTitleChange = useCallback(
		e => {
			e.persist();
			setJobTitle(e.target.value);
		},
		[setJobTitle],
	);

	const onCompanyCityChange = useCallback(
		e => {
			e.persist();
			setCompanyCity(e.target.value);
		},
		[setCompanyCity],
	);

	const onCompanyStateChange = useCallback(
		e => {
			e.persist();
			setCompanyState(e.target.value);
		},
		[setCompanyState],
	);

	const onCompanyCountryChange = useCallback(
		e => {
			e.persist();
			setCompanyCountry(e.target.value);
		},
		[setCompanyCountry],
	);

	const onContinue = useCallback(
		e => {
			handleNext();
		},
		[handleNext],
	);

	useEffect(() => {
		// validation
		const validation = !isEmpty(firstName) && !isEmpty(lastName) && !isEmpty(jobTitle);
		setIsValid(validation);
	}, [firstName, jobTitle, lastName]);

	const tabIndex = useMemo(() => (!isActiveStep ? { tabIndex: -1 } : {}), [isActiveStep]);

	const onKeyUpHandler = useCallback(
		e => {
			if (e && e.keyCode === 13 && isActiveStep && isValid) {
				onContinue();
			}
		},
		[isValid, isActiveStep, onContinue],
	);

	return (
		<Grid container spacing={5} className="step-container">
			<Grid item xs={12}>
				<h5 className="step-title" align="center">
					{title}
				</h5>
			</Grid>
			<Grid item xs={6}>
				<Input
					id="first-name"
					name="firstName"
					variant="outlined"
					value={firstName}
					label="First Name"
					fullWidth
					autoComplete="given-name"
					onChange={onFirstNameChange}
					inputProps={tabIndex}
					maxLength={30}
				/>
			</Grid>
			<Grid item xs={6}>
				<Input
					id="last-name"
					name="lastName"
					variant="outlined"
					value={lastName}
					label="Last Name"
					fullWidth
					autoComplete="family-name"
					onChange={onLastNameChange}
					inputProps={tabIndex}
					maxLength={30}
				/>
			</Grid>
			<Grid item xs={12}>
				<Input
					id="title"
					name="title"
					variant="outlined"
					value={jobTitle}
					label="Title"
					fullWidth
					autoComplete="organization-title"
					onChange={onJobTitleChange}
					inputProps={tabIndex}
					onKeyUp={onKeyUpHandler}
					maxLength={255}
				/>
			</Grid>
			<Hidden implementation="css" xsUp={true} xsDown={true}>
				<Grid item xs={12}>
					<input
						id="company-city"
						name="company-city"
						onChange={onCompanyCityChange}
						value={companyCity}
						autoComplete="self-service-city"
					/>
					<input
						id="company-state"
						name="company-state"
						onChange={onCompanyStateChange}
						value={companyState}
						autoComplete="self-service-state"
					/>
					<input
						id="company-country"
						name="company-country"
						onChange={onCompanyCountryChange}
						value={companyCountry}
						autoComplete="self-service-country"
					/>
				</Grid>
			</Hidden>
			<Grid item xs={12}>
				<Button
					color="primary"
					variant="contained"
					label="Continue"
					onClick={onContinue}
					onKeyUp={onKeyUpHandler}
					disabled={!isValid}
					fullWidth
					{...tabIndex}
				>
					{'Continue'}
				</Button>
			</Grid>
		</Grid>
	);
}
